import { html, css, LitElement } from 'lit';

import { customElement, property } from 'lit/decorators.js';
import * as echarts from 'echarts/core';
import { LineChart, ScatterChart, BarChart } from 'echarts/charts';
import { SVGRenderer, CanvasRenderer } from 'echarts/renderers';
import { UniversalTransition } from 'echarts/features';
import {
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  GraphicComponent,
  DataZoomComponent,
  MarkLineComponent,
  TitleComponent,
  GridComponent,
} from 'echarts/components';

import dark from './dark.json';

import { getQueryObject } from '../../decorators/query';

echarts.use([
  ToolboxComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
  GraphicComponent,
  DataZoomComponent,
  MarkLineComponent,
  GridComponent,
  LineChart,
  BarChart,
  ScatterChart,
  SVGRenderer,
  CanvasRenderer,
  UniversalTransition,
]);

echarts.registerTheme('dark', dark);

@customElement('ki-echart')
export default class KiEchart extends LitElement {
  static styles = css`
    :host {
      height: 100%;
      width: 100%;
      display: block;
      overflow: hidden;
    }
    .chart {
      height: 100%;
      width: 100%;
    }
  `;

  @property({ type: Object })
  options: any;

  @property({ type: Boolean })
  darkMode: boolean = false;

  @property({ type: Object, attribute: false })
  chart: any = false;

  @property({ type: Boolean })
  svgRenderer: boolean = true;

  get chartElement() {
    return getQueryObject(this, '#chart');
  }

  initChart() {
    this.chart = echarts.init(this.chartElement, this.darkMode ? 'dark' : '', {
      renderer: this.svgRenderer ? 'svg' : 'canvas',
    });
  }

  rerenderChart() {
    if (this.chart) {
      echarts.dispose(this.chart);
    }
    this.initChart();
    this.updated();
  }

  firstUpdated() {
    this.initChart();
  }

  updated() {
    if (
      this.chart &&
      this.options &&
      (!this.options.xAxis?.data || this.options.xAxis.data.length > 0)
    ) {
      this.chart.setOption(this.options);
    }
  }

  updateTheme(isDark: boolean) {
    this.darkMode = isDark;
    this.rerenderChart();
  }

  resize() {
    this.chart.resize();
  }

  render() {
    return html` <div id="chart" class="chart"></div> `;
  }
}
